/**
 * 访客服务（无需登录）
 * 用于登录、注册、忘记密码等
 */
import { guestApi, ApiError } from './api'

/**
 * 获取访客配置（邮箱白名单等）
 */
export async function getGuestConfig() {
  return guestApi.get('/api/v1/guest/comm/config')
}

/**
 * 发送邮箱验证码
 * @param {string} email - 邮箱地址
 */
export async function sendEmailVerify(email) {
  if (!email || !email.includes('@')) {
    throw new ApiError('请输入有效的邮箱地址', 'INVALID_EMAIL', 400)
  }
  return guestApi.post('/api/v1/passport/comm/sendEmailVerify', { email })
}

/**
 * 用户登录
 * @param {string} email - 邮箱
 * @param {string} password - 密码
 */
export async function login(email, password) {
  if (!email || !password) {
    throw new ApiError('邮箱和密码不能为空', 'MISSING_CREDENTIALS', 400)
  }
  return guestApi.post('/api/v1/passport/auth/login', { email, password })
}

/**
 * 用户注册
 * @param {Object} params
 * @param {string} params.email - 邮箱
 * @param {string} params.password - 密码
 * @param {string} params.email_code - 邮箱验证码
 * @param {string} [params.invite_code] - 邀请码（可选）
 * @param {string} [params.turnstile_token] - Turnstile 验证 token（可选）
 */
export async function register({ email, password, email_code, invite_code, turnstile_token }) {
  if (!email || !password) {
    throw new ApiError('邮箱和密码不能为空', 'MISSING_CREDENTIALS', 400)
  }
  if (!email_code) {
    throw new ApiError('请输入邮箱验证码', 'MISSING_CODE', 400)
  }
  
  const data = { email, password, email_code }
  if (invite_code) data.invite_code = invite_code
  if (turnstile_token) data.turnstile_token = turnstile_token
  
  return guestApi.post('/api/v1/passport/auth/register', data)
}

/**
 * 忘记密码
 * @param {Object} params
 * @param {string} params.email - 邮箱
 * @param {string} params.password - 新密码
 * @param {string} params.email_code - 邮箱验证码
 */
export async function forgotPassword({ email, password, email_code }) {
  if (!email || !password || !email_code) {
    throw new ApiError('请填写所有必填字段', 'MISSING_FIELDS', 400)
  }
  return guestApi.post('/api/v1/passport/auth/forget', { email, password, email_code })
}

export default {
  getGuestConfig,
  sendEmailVerify,
  login,
  register,
  forgotPassword,
}
